import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { onceEach, once } from "~/jose_modern/once.js";
import { buildFilterSummaryAndCleanParams } from "~/jose_modern/inventory/shared/inventory_adjustments/table_controls.js";

import "./reorder_guidelines.scss";

function toggleWithInputs(container, toggle = "##disable") {
  if (toggle === "##disable") {
    container.classList.add("is-hidden");
    container.querySelectorAll("input, select").forEach((el) => (el.disabled = true));
  } else {
    container.classList.remove("is-hidden");
    container.querySelectorAll("input, select").forEach((el) => (el.disabled = false));
  }
}

function initReorderingForms(container) {
  const rows = container.querySelectorAll("[data-partial='reorder_guidelines/inventory_row']");
  if (!rows) return;

  onceEach(rows, "reorder-guideline-inventory-row", (target) => {
    target.addEventListener("change", (ev) => {
      if (ev.target.name !== "inventory_reorder_guideline[calculation_method]") return;

      const newMethod = ev.target.value;
      const quantityFields = target.querySelector("[data-quantity-fields]");
      const timeFields = target.querySelector("[data-time-fields]");

      toggleWithInputs(quantityFields);
      toggleWithInputs(timeFields);

      if (newMethod === "quantity") {
        toggleWithInputs(quantityFields, "##enable");
      } else if (newMethod === "time") {
        toggleWithInputs(timeFields, "##enable");
        timeFields.querySelector("input").value = "";
      } else {
        // For "default" we only submit the form if the guideline exists
        if (newMethod === "default" && !target.querySelector("input[name='_method']")) return;

        window.Rails.fire(target.querySelector("form"), "submit");
      }
    });
  });
}

function initFilterToggle(container) {
  const tagFiltersButton = container.querySelector("#toggle-tag-filters");
  if (!tagFiltersButton) return;

  const filters = container.querySelector("#all-tag-filters");

  once(tagFiltersButton, "filter-toggle", (target) => {
    target.addEventListener("click", (ev) => {
      ev.preventDefault();

      const isHidden = filters.classList.toggle("is-hidden");
      tagFiltersButton.setAttribute("aria-expanded", !isHidden);

      tagFiltersButton.querySelector("#toggle-tag-filter-text").textContent = isHidden
        ? buildFilterSummaryAndCleanParams()
        : "Hide Filters";
    });
  });
}

function initIncludeArchived(container) {
  const includeArchivedCheckbox = container.querySelector("#include_archived");
  if (!includeArchivedCheckbox) return;

  const archivedLink = includeArchivedCheckbox.parentNode.querySelector("a");

  once(includeArchivedCheckbox, "include-archived", (target) => {
    target.addEventListener("click", (ev) => {
      archivedLink.click();
    });
  });
}

function initUserGuidelineForm(container) {
  const form = container.querySelector(
    "[data-partial='user_reorder_guidelines/user_guideline_form']"
  );
  if (!form) return;

  once(form, "user-guideline-form", (target) => {
    target.addEventListener("change", (ev) => {
      if (ev.target.name !== "user_reorder_guideline[calculation_method]") return;

      const newMethod = ev.target.value;
      const timeFields = target.querySelector("[data-time-fields]");
      const unitField = target.querySelector("input[name='user_reorder_guideline[unit]']");

      toggleWithInputs(timeFields);

      if (newMethod === "time") {
        toggleWithInputs(timeFields, "##enable");
        unitField.disabled = false;
      } else if (newMethod === "do_not_reorder") {
        unitField.disabled = true;

        window.Rails.fire(target.querySelector("form"), "submit");
      }
    });
  });
}

const scan = (container) => {
  initReorderingForms(container);
  initUserGuidelineForm(container);
  initFilterToggle(container);
  initIncludeArchived(container);
};

onViewLoad("reorder_guidelines#edit", () => {
  scan(document);
  document.addEventListener("partial:replace", (ev) => scan(ev.container));
});
